module.exports = __webpack_public_path__ + "images/referenzen/socialmedia/beetle_and_animals_minihorse_small.jpg";